import React from "react";

const BottomFooter = () => {
	return (
		<div className="bottom-footer bg-dark border-top py-8">
			<div className="container container-lg">
				<div className="bottom-footer__inner text-center">
					<p className="bottom-footer__text text-light ">
						Udemandme.com ©2018-2025. All Rights Reserved{" "}
					</p>
				</div>
			</div>
		</div>
	);
};

export default BottomFooter;
